export default "__VITE_ASSET__kq1aha3X__"